import { post, downloadFile } from 'utils/api';

function reportLimitQuerySuffix(data) {
  if (!data || data.limit == null || data.limit === '') return '';
  const n = parseInt(data.limit, 10);
  if (Number.isNaN(n)) return '';
  delete data.limit;
  return `&limit=${n}`;
}

export const stationUnitConsumption = (data) => {
  const limitSuffix = reportLimitQuerySuffix(data);
  const page = data.page ? data.page : 1;
  if (data.sortBy && page && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/report/unitconsumption?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}${limitSuffix}`, data);
  } else if (page && data.search) {
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['search'];
    return post(`/report/unitconsumption?page=${parseInt(page)}&search=${search}${limitSuffix}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['search'];
    delete data['sortBy'];
    return post(`/report/unitconsumption?search=${search}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/report/unitconsumption?page=${parseInt(page)}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return post(`/report/unitconsumption?search=${search}${limitSuffix}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/report/unitconsumption?sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.is_rfid_based_booking) {
    if (data.is_rfid_based_booking === 'OTP') {
      delete data['page'];
      delete data['is_rfid_based_booking'];
      return post(`/report/unitconsumption?page=${parseInt(page)}&is_rfid_based_booking=${false}${limitSuffix}`, data);
    }
    if (data.is_rfid_based_booking === 'RFID') {
      delete data['page'];
      delete data['is_rfid_based_booking'];
      return post(`/report/unitconsumption?page=${parseInt(page)}&is_rfid_based_booking=${true}${limitSuffix}`, data);
    }
  } else {
    delete data['page'];
    return post(`/report/unitconsumption?page=${parseInt(page)}${limitSuffix}`, data);
  }
};

export const b2bStationChargingHistory = (data) => {
  return post('/charger_bookings/charginghistory', data);
};

export const b2cStationChargingHistory = (data) => {
  return post('/charger_bookings/charginghistory', data);
};

export const jsonRequestResponseReport = (data) => {
  return post('/charger_logs/report', data);
};

export const walletTransactionReport = (data) => {
  return post('/wallets/report', data);
};

export const moneyTransactionPgReport = (data) => {
  return post('/payments/reports', data);
};

export const appUserDetailsList = (data) => {
  return post('/users/appreports', data);
};

export const mostVehicleChargedList = (data) => {
  return post('/charger_bookings/vehiclescharged', data);
};

export const bookingHistory = (data) => {
  return post('/charger_bookings/charginghistory', data);
};

export const userChargingHistory = (data) => {
  return post('/charger_bookings/charginghistory', data);
};

export const stationChargingSummary = (data) => {
  const page = data.page ? data.page : 1;
  if (page && data.search && data.sortBy) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/report/chargingsummary?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}`, data);
  } else if (page && data.search) {
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['search'];
    return post(`/report/chargingsummary?page=${parseInt(page)}&search=${search}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['search'];
    delete data['sortBy'];
    return post(`/report/chargingsummary?search=${search}&sortBy=${sortBy}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/report/chargingsummary?page=${parseInt(page)}&sortBy=${sortBy}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return post(`/report/chargingsummary?search=${search}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/report/chargingsummary?sortBy=${sortBy}`, data);
  } else {
    delete data['page'];
    return post(`/report/chargingsummary?page=${parseInt(page)}`, data);
  }
};

export const bookingSummaryReport = (data) => {
  return post('/charger_bookings/summary', data);
};

export const downloadStationChargingSummary = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/report/chargingsummary?search=${search}`, data);
  } else {
    return downloadFile(`/report/chargingsummary`, data);
  }
};

export const downloadBookingHistory = (data) => {
  return downloadFile(`/charger_bookings/charginghistory`, data);
};

export const downloadUserChargingHistory = (data) => {
  return downloadFile(`/charger_bookings/charginghistory`, data);
};

export const downloadMoneyTransactionPGReport = (data) => {
  return downloadFile('/payments/reports', data);
};

export const downloadWalletTransactionReport = (data) => {
  return downloadFile('/wallets/report', data);
};

export const downloadB2CStationChargingHistory = (data) => {
  return downloadFile('/charger_bookings/charginghistory', data);
};

export const downloadStationUnitConsumption = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/report/unitconsumption?search=${search}`, data);
  } else {
    return downloadFile('/report/unitconsumption', data);
  }
};

export const accessReport = (data) => {
  const limitSuffix = reportLimitQuerySuffix(data);
  const page = data.page ? data.page : 1;
  if (page && data.search && data.sortBy) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/report/accessreport?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}${limitSuffix}`, data);
  } else if (page && data.search) {
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['search'];
    return post(`/report/accessreport?page=${parseInt(page)}&search=${search}${limitSuffix}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['search'];
    delete data['sortBy'];
    return post(`/report/accessreport?search=${search}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/report/accessreport?page=${parseInt(page)}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return post(`/report/accessreport?search=${search}${limitSuffix}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/report/accessreport?sortBy=${sortBy}${limitSuffix}`, data);
  } else {
    delete data['page'];
    return post(`/report/accessreport?page=${parseInt(page)}${limitSuffix}`, data);
  }
};

export const downloadAccessReport = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/report/accessreport?search=${search}`, data);
  } else {
    return downloadFile('/report/accessreport', data);
  }
};

export const getCapacityUtilisation = (data) => {
  const page = data.page ? data.page : 1;
  if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/charger_state/capacityutilization?page=${parseInt(page)}&sortBy=${sortBy}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/charger_state/capacityutilization?sortBy=${sortBy}`, data);
  } else {
    delete data['page'];
    return post(`/charger_state/capacityutilization?page=${parseInt(page)}`, data);
  }
};

export const downloadCapacityUtilisation = (data) => {
  return downloadFile(`/charger_state/capacityutilization`, data);
};

export const stationDownTimeReport = (data) => {
  const limitSuffix = reportLimitQuerySuffix(data);
  const page = data.page ? data.page : 1;
  if (page && data.search && data.sortBy) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/charger_downtime/summary?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}${limitSuffix}`, data);
  } else if (page && data.search) {
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['search'];
    return post(`/charger_downtime/summary?page=${parseInt(page)}&search=${search}${limitSuffix}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['search'];
    delete data['sortBy'];
    return post(`/charger_downtime/summary?search=${search}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/charger_downtime/summary?page=${parseInt(page)}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return post(`/charger_downtime/summary?search=${search}${limitSuffix}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/charger_downtime/summary?sortBy=${sortBy}${limitSuffix}`, data);
  } else {
    delete data['page'];
    return post(`/charger_downtime/summary?page=${parseInt(page)}${limitSuffix}`, data);
  }
};

export const downloadStationDownTimeReport = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/charger_downtime/report?search=${search}`, data);
  } else {
    return downloadFile(`/charger_downtime/report`, data);
  }
};

export const chargeTransactionReport = (data) => {
  const limitSuffix = reportLimitQuerySuffix(data);
  const page = data.page ? data.page : 1;
  if (page && data.search && data.sortBy) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/report/chargetransactions?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}${limitSuffix}`, data);
  } else if (page && data.search) {
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['search'];
    return post(`/report/chargetransactions?page=${parseInt(page)}&search=${search}${limitSuffix}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['search'];
    delete data['sortBy'];
    return post(`/report/chargetransactions?search=${search}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/report/chargetransactions?page=${parseInt(page)}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return post(`/report/chargetransactions?search=${search}${limitSuffix}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/report/chargetransactions?sortBy=${sortBy}${limitSuffix}`, data);
  } else {
    delete data['page'];
    return post(`/report/chargetransactions?page=${parseInt(page)}${limitSuffix}`, data);
  }
};

export const downloadChargeTransactionReport = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/report/chargetransactions?search=${search}`, data);
  } else {
    return downloadFile(`/report/chargetransactions`, data);
  }
};

export const failedTransactionReport = (data) => {
  const limitSuffix = reportLimitQuerySuffix(data);
  const page = data.page ? data.page : 1;
  if (page && data.search && data.sortBy) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/report/failedTransactions?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}${limitSuffix}`, data);
  } else if (page && data.search) {
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['search'];
    return post(`/report/failedTransactions?page=${parseInt(page)}&search=${search}${limitSuffix}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['search'];
    delete data['sortBy'];
    return post(`/report/failedTransactions?search=${search}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/report/failedTransactions?page=${parseInt(page)}&sortBy=${sortBy}${limitSuffix}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return post(`/report/failedTransactions?search=${search}${limitSuffix}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/report/failedTransactions?sortBy=${sortBy}${limitSuffix}`, data);
  } else {
    delete data['page'];
    return post(`/report/failedTransactions?page=${parseInt(page)}${limitSuffix}`, data);
  }
};

export const downloadFailedTransactionReport = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/report/failedTransactions?search=${search}`, data);
  } else {
    return downloadFile(`/report/failedTransactions`, data);
  }
};

export const stationChargingSummaryChart = (data) => {
  const page = data.page ? data.page : 1;
  if (page && data.search && data.sortBy) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/report/chargingSummaryChart?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}`, data);
  } else if (page && data.search) {
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['search'];
    return post(`/report/chargingSummaryChart?page=${parseInt(page)}&search=${search}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['search'];
    delete data['sortBy'];
    return post(`/report/chargingSummaryChart?search=${search}&sortBy=${sortBy}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/report/chargingSummaryChart?page=${parseInt(page)}&sortBy=${sortBy}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return post(`/report/chargingSummaryChart?search=${search}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/report/chargingSummaryChart?sortBy=${sortBy}`, data);
  } else {
    delete data['page'];
    return post(`/report/chargingSummaryChart?page=${parseInt(page)}`, data);
  }
};

export const downloadPDFStationDownTimeReport = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/charger_downtime/pdfReport?search=${search}`, data);
  } else {
    return downloadFile(`/charger_downtime/pdfReport`, data);
  }
};

// CR13 - CPMS Dashboard Phase 6, Milestone 3: Error Code Report
export const errorCodeReport = (data) => {
  const page = data.page ? data.page : 1;
  if (page && data.search && data.sortBy) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/report/errorcode?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}`, data);
  } else if (page && data.search) {
    const search = encodeURIComponent(data.search);
    delete data['page'];
    delete data['search'];
    return post(`/report/errorcode?page=${parseInt(page)}&search=${search}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = encodeURIComponent(data.search);
    delete data['search'];
    delete data['sortBy'];
    return post(`/report/errorcode?search=${search}&sortBy=${sortBy}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/report/errorcode?page=${parseInt(page)}&sortBy=${sortBy}`, data);
  } else if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return post(`/report/errorcode?search=${search}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/report/errorcode?sortBy=${sortBy}`, data);
  } else {
    delete data['page'];
    return post(`/report/errorcode?page=${parseInt(page)}`, data);
  }
};

export const downloadErrorCodeReport = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/report/errorcode?search=${search}`, data);
  } else {
    return downloadFile(`/report/errorcode`, data);
  }
};

export const downloadPDFErrorCodeReport = (data) => {
  if (data.search) {
    const search = encodeURIComponent(data.search);
    delete data['search'];
    return downloadFile(`/report/errorcode?search=${search}`, data);
  } else {
    return downloadFile(`/report/errorcode`, data);
  }
};

export const dataReport = {
  stationUnitConsumption,
  b2bStationChargingHistory,
  b2cStationChargingHistory,
  jsonRequestResponseReport,
  walletTransactionReport,
  moneyTransactionPgReport,
  appUserDetailsList,
  bookingHistory,
  mostVehicleChargedList,
  userChargingHistory,
  stationChargingSummary,
  bookingSummaryReport,
  downloadStationChargingSummary,
  downloadBookingHistory,
  downloadUserChargingHistory,
  downloadMoneyTransactionPGReport,
  downloadWalletTransactionReport,
  downloadB2CStationChargingHistory,
  downloadStationUnitConsumption,
  downloadAccessReport,
  accessReport,
  getCapacityUtilisation,
  downloadCapacityUtilisation,
  stationDownTimeReport,
  downloadStationDownTimeReport,
  chargeTransactionReport,
  downloadChargeTransactionReport,
  failedTransactionReport,
  downloadFailedTransactionReport,
  stationChargingSummaryChart,
  downloadPDFStationDownTimeReport,
  errorCodeReport,
  downloadErrorCodeReport,
  downloadPDFErrorCodeReport,
};
